export function drawCircle(
    context: CanvasRenderingContext2D,
    x: number,
    y: number,
    radius: number,
) {
    context.moveTo(x + radius, y);
    context.arc(x, y, radius, 0, Math.PI * 2);
}
